import type { TabItem } from '../../components/common/TabBar/TabBar';

export type HomeDashboardKey =
  | 'delinquency'
  | 'due'
  | 'goals'
  | 'payments'
  | 'performanceSupport'
  | 'recentBodyPhotos'
  | 'sensitiveStudents';

export type HomeDashboardItem = TabItem & {
  key: HomeDashboardKey;
  path: string;
  icon: string;
};

export const HOME_DASHBOARD_ITEMS: HomeDashboardItem[] = [
  { key: 'delinquency', label: 'Inadimplentes', path: '/', icon: 'credit_card_off' },
  { key: 'goals', label: 'Metas', path: '/metas', icon: 'flag' },
  { key: 'payments', label: 'Pagamentos', path: '/recebimentos', icon: 'payments' },
  { key: 'due', label: 'A vencer/vencidos', path: '/a-vencer', icon: 'event_upcoming' },
  { key: 'performanceSupport', label: 'Suporte', path: '/suporte-performance', icon: 'support_agent' },
  { key: 'recentBodyPhotos', label: 'Fotos recentes', path: '/fotos-recentes', icon: 'photo_library' },
  { key: 'sensitiveStudents', label: 'Alunas sensíveis', path: '/alunas-sensiveis', icon: 'favorite' },
];

export const getHomeDashboardKey = (pathname: string): HomeDashboardKey => (
  HOME_DASHBOARD_ITEMS.find((item) => item.path === pathname)?.key ?? 'delinquency'
);

export const isHomeDashboardPath = (pathname: string): boolean => (
  HOME_DASHBOARD_ITEMS.some((item) => item.path === pathname)
);
